<template>
  <div style="overflow-x: hidden !important;">
    <v-data-table :headers="headers" :items="mediosOrdered" disable-pagination hide-default-footer auto-resize>
      <template #no-data>
        <p>No hay medios asignados.</p>
      </template>

      <template #item="{ item }">
        <tr @dblclick="zoomMedio(item.ID_MEDIO)" :style="rowColor(item)">
          <td style="text-overflow: ellipsis;max-width: 150px;white-space: nowrap;overflow: hidden;">
            {{ item.MEDIO }} <span v-show="isMedioFueraHorario(item.ID_MEDIO)" class="font-weight-black">*</span>
          </td>

          <td>
            {{ item.FECHA_AVISO | formatDate }}
          </td>

          <td>
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" :class="{ 'underline': item.FECHA_LLEGADA_GEOFENCING }">{{ item.FECHA_LLEGADA | formatDate }}</span>
              </template>
              <span v-if="item.FECHA_LLEGADA_GEOFENCING">Geofencing: {{ item.FECHA_LLEGADA_GEOFENCING | formatDate }}</span>
              <span v-else>Geofencing: no hay</span>
            </v-tooltip>
          </td>

          <td>
            {{ item.FECHA_SALIDA | formatDate }}
          </td>

          <td>
            {{ item.FECHA_LLEGADA_BASE | formatDate }}
          </td>

          <td>
            <v-layout>
              <!-- Tiempo -->
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-btn fab icon small v-bind="attrs" v-on="on" v-show="!item.FECHA_FIN_DESCANSO" :disabled="isClockButtonDisabled(item)" @click="setFechas(item)">
                    <v-icon color="black"> {{ !item.FECHA_LLEGADA_BASE ? 'mdi-clock-outline' : 'mdi-sleep' }}</v-icon>
                  </v-btn>
                </template>
                <span v-if="!item.FECHA_LLEGADA">Asignar llegada</span>
                <span v-if="item.FECHA_LLEGADA && !item.FECHA_SALIDA">Asignar salida</span>
                <span v-if="item.FECHA_SALIDA && !item.FECHA_LLEGADA_BASE">Asignar llegada base</span>
                <span v-if="item.FECHA_LLEGADA_BASE && !item.FECHA_FIN_DESCANSO">Asignar descanso</span>
              </v-tooltip>

              <!-- Editar -->
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-btn fab icon small v-bind="attrs" v-on="on" @click="editMedio(item)" :disabled="disabledByRol">
                    <v-icon color="black">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar medio</span>
              </v-tooltip>
            </v-layout>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="showDialogDescanso" persistent max-width="400">
      <v-card>
        <v-toolbar color="primaryLight" dark dense>
          <v-toolbar-title>Establecer descanso del medio</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pt-8">
          <v-form v-model="isValid">
            <v-container>
              <v-row align="center" justify="center" no-gutters>
                <v-col>
                  <v-slider v-model="horasDescanso" :min="0" :max="23" thumb-label="always" ticks="always" label="Horas descanso" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-slider v-model="minutosDescanso" :min="0" :max="59" thumb-label="always" ticks="always" label="Minutos descanso" />
                </v-col>
              </v-row>
              <v-row align="center" justify="center" no-gutters>
                <v-col>
                  <v-text-field v-model="fechaFinDescanso" label="Fecha fin de descanso" prepend-icon="esri-icon-calendar" outlined readonly hide-details />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text color="red" @click="showDialogDescanso = false">Cancelar</v-btn>
          <v-btn text color="green" @click="setFechaFinDescanso">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import constants from '../../../helpers/constants'
import * as ArcGIS from '../../../helpers/ArcGIS'
import DateService, { FMT, DayjsUnit } from '@/helpers/DateService'

export default {
  props: {
    medios: Array
  },

  data: () => ({
    headers: [
      { text: 'Medio', value: 'MEDIO', align: 'left', sortable: true, width: '16%' },
      { text: 'Aviso', value: 'FECHA_AVISO', align: 'center', sortable: true, width: '16%' },
      { text: 'Llegada', value: 'FECHA_LLEGADA', align: 'center', sortable: true, width: '16%' },
      { text: 'Salida', value: 'FECHA_SALIDA', align: 'center', sortable: true, width: '16%' },
      { text: 'Base', value: 'FECHA_LLEGADA_BASE', align: 'center', sortable: true, width: '16%' },
      { text: '', value: 'ACCIONES', align: 'center', sortable: false, width: '20%' }
    ],

    estadoMedios: [],
    showDialogDescanso: false,
    medioSelected: {},
    isValid: false,
    horasDescanso: null,
    minutosDescanso: null
  }),
  computed: {
    allMedios () {
      return this.$store.getters['medio/medios']
    },

    fechaFinDescanso () {
      let finDescanso = null
      if (this.medioSelected) {
        let llegadaBase = this.$date.parseDate(this.medioSelected.FECHA_LLEGADA_BASE)
        finDescanso = llegadaBase.add(this.horasDescanso, DayjsUnit.Hour)
        finDescanso = finDescanso.add(this.minutosDescanso, DayjsUnit.Minute).format(FMT.date)
      }
      return finDescanso
    },

    mediosOrdered () {
      let medios = []

      if (this.medios) {
        medios = this.orderMedios()
      }

      return medios
    },

    disabledByRol () {
      // Deshabilita funciones dependiendo del rol
      return !this.$store.getters['usuario/isCurrentUsuarioAdmin']
    }
  },

  methods: {
    rowColor (item) { // TODO: esto hay que rehacerlo
      let backgroundColor = '#CCC8C5'
      let borderColor = '#CCC8C5'

      // console.log(item)

      if (!item.FECHA_LLEGADA) {
        backgroundColor = this.estadoMedios[1].COLOR // Azul
        borderColor = this.estadoMedios[1].COLOR
      } else if (!item.FECHA_SALIDA) {
        backgroundColor = this.estadoMedios[2].COLOR // Rojo
        borderColor = this.estadoMedios[2].COLOR
      } else if (!item.FECHA_LLEGADA_BASE) {
        backgroundColor = this.estadoMedios[3].COLOR // Amarillo
        borderColor = this.estadoMedios[3].COLOR
      }

      return {
        'background-color': backgroundColor,
        'border-color': borderColor
      }
    },

    isMedioFueraHorario (idMedio) {
      let isMedioFueraHorario = false

      let medio = this.allMedios.find(x => x.ID_MEDIO === idMedio)
      if (medio) {
        let horaSalidaMedio = this.$date.parseDate(medio.HORA_SALIDA, FMT.time).format(FMT.time)
        let horaActual = this.$date.formatDate(this.$date.now(), FMT.time)
        isMedioFueraHorario = horaActual > horaSalidaMedio
      }
      return isMedioFueraHorario
    },

    orderMedios () {
      let order = JSON.parse(JSON.stringify(this.medios))

      let mediosOrder = order.sort((a, b) => {
        let aEstado = a.ESTADO
        let bEstado = b.ESTADO
        let aMedio = a.MEDIO.toUpperCase()
        let bMedio = b.MEDIO.toUpperCase()

        if (aEstado === bEstado) {
          return (aMedio < bMedio) ? -1 : (aMedio > bMedio) ? 1 : 0
        } else {
          return (aEstado < bEstado) ? -1 : 1
        }
      })

      return mediosOrder
    },

    editMedio (medio) {
      this.$emit('editMedioEmergencia', medio)
    },

    isClockButtonDisabled (medio) {
      let now = this.$date.now()
      let fechaAviso = this.$date.parseDate(medio.FECHA_AVISO)
      let fechaLlegada = this.$date.parseDate(medio.FECHA_LLEGADA)
      let fechaSalida = this.$date.parseDate(medio.FECHA_SALIDA)
      return fechaAviso > now || fechaLlegada > now || fechaSalida > now
    },

    // Click btn reloj
    setFechas (medio) {
      let now = this.$date.now()

      if (!Array.isArray(medio.ESTADO)) {
        medio.ESTADO = []
      }

      const fechasEstados = [
        { fecha: 'FECHA_LLEGADA', estado: this.$store.state.incendio.tiposIncendioEstado[0].VALUE },
        { fecha: 'FECHA_SALIDA', estado: this.$store.state.incendio.tiposIncendioEstado[1].VALUE },
        { fecha: 'FECHA_LLEGADA_BASE', estado: this.$store.state.incendio.tiposIncendioEstado[2].VALUE },
        { fecha: 'FECHA_FIN_DESCANSO', estado: this.$store.state.incendio.tiposIncendioEstado[3].VALUE },
        { fecha: 'FECHA_FINALIZACION', estado: this.$store.state.incendio.tiposIncendioEstado[4].VALUE },
        { fecha: null, estado: this.$store.state.incendio.tiposIncendioEstado[5].VALUE }
      ]

      for (const { fecha, estado } of fechasEstados) {
        if (!fecha || !medio[fecha]) {
          if (fecha) medio[fecha] = now // Establece la fecha
          if (!medio.ESTADO.includes(estado)) {
            medio.ESTADO = [...medio.ESTADO, estado] // Agregar estado
          }
          break
        }
      }

      if (!this.showDialogDescanso) {
        this.$emit('setFecha', medio)
      }
    },

    setFechaFinDescanso () {
      this.showDialogDescanso = false
      this.medioSelected.FECHA_FIN_DESCANSO = this.$date.parseDate(this.fechaFinDescanso)
      this.$emit('setFecha', this.medioSelected)
    },

    zoomMedio (idMedio) {
      let medio = this.allMedios.find(x => x.ID_MEDIO === idMedio)
      if (medio && medio.ULT_POSICION) {
        let center = {
          target: [medio.ULT_POSICION.LONGITUD, medio.ULT_POSICION.LATITUD],
          zoom: 17
        }

        ArcGIS.setCenterMap(center)
      }
    }
  },

  created () {
    this.estadoMedios = constants.estadosMedio
  }
}
</script>

<style scoped>
</style>
